import { render, staticRenderFns } from "./fieldMoney.vue?vue&type=template&id=8c90ca64&"
import script from "./fieldMoney.vue?vue&type=script&lang=js&"
export * from "./fieldMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports